import "./Notes.scss";

import { memo, useState } from "react";
import type { NoteType } from "types/DataTypes";

import type { NotesEntity } from "./notesAdapter";
import NotesList from "./NotesList";

type NotesProps = {
  entity: NotesEntity;
  className?: string;
  /** card heading, defaults to "Notes" */
  heading?: string;
  /** extra class names applied to the notes card */
  cardClassNames?: string;
};

const Notes = ({ entity, className, heading, cardClassNames }: NotesProps) => {
  const [editingNote, setEditingNote] = useState<NoteType | null>(null);

  const handleEditNote = (note: NoteType) => {
    setEditingNote(note);
  };

  const handleEditComplete = () => {
    setEditingNote(null);
  };

  if (!entity) {
    return (
      <div className={`Notes ${className || ""}`}>
        <div className="Notes__error">
          <p>Unable to load notes</p>
        </div>
      </div>
    );
  }

  return (
    <div className={`Notes ${className || ""}`}>
      <NotesList
        entity={entity}
        heading={heading}
        cardClassNames={cardClassNames}
        onEditNote={handleEditNote}
        editingNote={editingNote}
        onEditComplete={handleEditComplete}
      />
    </div>
  );
};

export default memo(Notes);
